import type { ReactNode } from 'react'

import type { ProductSummary } from '@aeris/contracts'
import { CopyableValue } from '@aeris/ui'

/**
 * Quem é o produto, no cabeçalho da ficha e do Editar — F248.
 *
 * *"No editar do produto tem que mostrar o id do produto."* O código é o que a
 * loja fala (é o "Cód." do pedido da loja e da etiqueta); o código de barras é
 * o que o leitor lê; o ID é o do sistema, para quando o suporte pede. Os três
 * copiam com um clique.
 *
 * O ID aparece pelo FIM: num UUIDv7 o começo é a hora do cadastro, e os 5 mil
 * produtos importados juntos começam todos igual. O fim é o que os distingue.
 */
export const ProductIdentity = ({
  product,
}: {
  readonly product: ProductSummary
}): ReactNode => {
  const main =
    product.variants.find((variant) => variant.isDefault) ?? product.variants[0]

  return (
    <>
      {main === undefined ? null : (
        <CopyableValue label="Cód." value={main.sku} what="código" />
      )}
      {main?.gtin == null ? null : (
        <CopyableValue
          label="Barras"
          value={main.gtin}
          what="código de barras"
        />
      )}
      <CopyableValue
        label="ID"
        value={product.id}
        display={`…${product.id.slice(-8)}`}
        what="o ID do produto"
      />
    </>
  )
}
